import * as React from "react";

import { List, Stack, Text, Title } from "@mantine/core";

import { UpdateList } from "../components/UpdateList";
import { WhatsNewUpdate } from "../update";

export const update20240115: WhatsNewUpdate = {
  id: "D9FF899C-BAE5-4272-88D3-05DFE661B195",
  date: "2024-01-15",
  subject: "New fonts and minor fixes",
  content: (
    <Stack>
      <Text>
        This update adds a new default Sans-Serif option for typography in generated documents. This
        replaces the prior Helvetica default and improves compatibility across a variety of browsers
        and operating systems. I also added the{" "}
        <a href="https://b612-font.com/" target="_blank">
          B612 font
        </a>{" "}
        for kicks.
      </Text>
      <Stack spacing="xs">
        <Title order={5}>Fixes</Title>
        <UpdateList>
          <List.Item>
            Addressed documents defaulting to use Helvetica, which broke document generation on
            Windows.
          </List.Item>
          <List.Item>
            Fixed a bug that would cause the first document in the library from being downloadable
            or shareable.
          </List.Item>
          <List.Item>Made PDF downloading a little bit more robust.</List.Item>
        </UpdateList>
      </Stack>
    </Stack>
  ),
};
